const TOOLBAR_SLOTS = 8
const MIN_GLITCHES = 6
const MIN_PARTS = 2

function getRandomIntInclusive (minParam, maxParam) {
  const min = Math.ceil(minParam)
  const max = Math.floor(maxParam)
  return Math.floor((Math.random() * (max - min + 1)) + min)
}

function getRandomElements (items, n) {
  return items
    .map(x => ({ x, r: Math.random() }))
    .sort((a, b) => a.r - b.r)
    .map(a => a.x)
    .slice(0, n)
}

function getRandomToolbar (availableGlitches, availableParts) {
  const numberOfGlitches = getRandomIntInclusive(
    MIN_GLITCHES,
    TOOLBAR_SLOTS - MIN_PARTS
  )
  const numberOfParts = TOOLBAR_SLOTS - numberOfGlitches
  const glitches = getRandomElements(
    availableGlitches.map(g => g.id),
    numberOfGlitches
  )
  const parts = getRandomElements(availableParts.map(p => p.id), numberOfParts)
  return {glitches, parts}
}
module.exports = {
  getRandomElements,
  getRandomToolbar,
  getRandomIntInclusive
}
